"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.array.fill");
var _regenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
require("core-js/modules/web.dom.iterable");
var _objectDestructuringEmpty2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectDestructuringEmpty.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _defineProperty2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _axios = _interopRequireDefault(require("axios"));
var _index = _interopRequireDefault(require("@/components/Store/RangePick/index.vue"));
var _doubleWeekPlan = require("@/http/interface/sfe/doubleWeekPlan");
var _dialog = _interopRequireDefault(require("@/mixins/dialog"));
var _myform = _interopRequireDefault(require("@/mixins/myform"));
var _timeConflit = _interopRequireDefault(require("../mixins/timeConflit"));
var _utils = require("@/components/Store/utils");
var _index2 = require("../statics/index");
var _index3 = _interopRequireDefault(require("@/components/Common/FormCascaderBySR/index.vue"));
var _PlanMap = _interopRequireDefault(require("@/views/sfe/doubleWeekPlan/components/PlanMap2.vue"));
var _elementUi = require("element-ui");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** package */
/** components */
/** services */
/** mixins */
/** utils */
/** statics */
// 类型 ，计划、任务，由前端自行维护
var _default2 = exports.default = {
  components: {
    PlanMap2: _PlanMap.default,
    FormCascaderBySR: _index3.default,
    RangePick: _index.default
  },
  mixins: [_dialog.default, _myform.default, _timeConflit.default],
  props: {
    // 左侧table选中的date具体信息
    actDateinfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 所有下拉options配置
    /**
     * optConfig.visitPurposeOptions: [], // 拜访目的select
     * optConfig.rtmOptions: [], // 门店RTM类型select
     * optConfig.storeCategoryOptions: [], // 客户类型select（零售店类别）
     * optConfig.tppOptions: [], // TPP签约量select
     * optConfig.storeStructureOptions: [], // 零售店性质select
     * optConfig.ssbtypeOptions: [], // 店招品牌select
     * optConfig.daMethodOptions: [], // 记账方式select
     * optConfig.tireSupplierOptions: [], // 主要进货渠道select
     * optConfig.accountMethodOptions: [], // 结算方式select
     * optConfig.tyreBrandOptions: [], // 轮胎品牌select
     * optConfig.mainserviceOptions: [], // 主要服务项目select
     */
    optConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var defaultForm = {
      planTaskStartTime: '',
      planTaskEndTime: ''
    };
    var default_SearchForm = {
      subjectType: '',
      storeName: '',
      // 门店名称
      storeCode: '',
      // 门店编号
      contactor: '',
      // 门店联系人
      PCD: [],
      // 省市区 不传后端
      province: '',
      // 省label
      provinceCode: '',
      // 省
      city: '',
      // 市label
      cityCode: '',
      // 市
      district: '',
      // 区label
      districtCode: '',
      // 区
      storeAddr: '',
      // 门店地址
      retailerType: '',
      // 店面级别（零售店类别）
      rtlRtmCategory: '',
      // 客户类型(零售店RTM类型)
      isBaiLian: '',
      mainBusiness: '',
      signBoardBrand: '',
      storeType: '',
      storeContact: '',
      checkedStoreCodeList: [],
      bLat: 0.0,
      bLong: 0.0,
      distanceBetweenVisits: 'distance3'
    };
    var default_stepOneDataForm = {
      planTaskDate: '',
      planTaskStartTime: '09:00',
      planTaskEndTime: '17:00',
      subjectType: '',
      PCD: [],
      province: '',
      provinceCode: '',
      city: '',
      cityCode: '',
      district: '',
      districtCode: ''
    };
    var default_stepTwoDataForm = {
      storeCheckList: []
    };
    var default_stepThreeDataForm = {
      storeCheckList: [],
      recommendedStoreCheckList: []
    };
    var default_stepFourDataForm = {
      firstStore: '',
      lastStore: ''
    };
    return (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
      isShowAddMoreStoreModel: true,
      activeStep: 0,
      PT_STATUS_PLAN: _index2.PT_STATUS_PLAN,
      // 计划
      PT_STATUS_TASK: _index2.PT_STATUS_TASK,
      // 任务
      actualPlanTaskFlag: 'N',
      // Y:实际任务；N:计划任务
      /** form group */
      formLabelWidth: '120px',
      isShowModel: false,
      isShowRecommendModel: false,
      isShowBackPreviousStepModel: false,
      isShowRePlanningModel: false,
      dialogStatus: 'create',
      pickerOptions: {
        start: '00:00',
        end: '23:30',
        step: '00:30'
      },
      regionProps: {
        expandTrigger: 'hover',
        checkStrictly: true
      },
      form: Object.assign({}, defaultForm),
      initForm: Object.assign({}, defaultForm),
      taskForm: {
        visitPurpose1: '',
        // 拜访目的1
        visitPurpose2: '',
        // 拜访目的2
        remark: '' // 拜访目的的简要说明
      },
      rules: {
        validateIpt: [{
          required: true,
          trigger: ['blur'],
          message: this.$t('errorValid.empty')
        }],
        validateChoose: [{
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.emptySelect')
        }]
      },
      /** search + table */
      searchForm: Object.assign({}, default_SearchForm),
      stepOneDataForm: Object.assign({}, default_stepOneDataForm),
      stepTwoDataForm: Object.assign({}, default_stepTwoDataForm),
      stepThreeDataForm: Object.assign({}, default_stepThreeDataForm),
      stepFourDataForm: Object.assign({}, default_stepFourDataForm),
      table_main: {
        listLoading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        list: [],
        sourceApi: null,
        // api timer
        storeChecked: [],
        // 访店计划流程 store info array
        storeCheckedList: [],
        taskStoreChecked: {} // 访店任务流程 store info
      },
      table_other: {
        listLoading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        list: [],
        sourceApi: null,
        // api timer
        storeChecked: [],
        // 访店计划流程 store info array
        storeCheckedList: [],
        taskStoreChecked: {} // 访店任务流程 store info
      },
      table_recommend: {
        listLoading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        list: [],
        sourceApi: null,
        // api timer
        storeChecked: [],
        // 访店计划流程 store info array
        storeCheckedList: [],
        taskStoreChecked: {} // 访店任务流程 store info
      },
      /** other */
      canSubmit: true,
      /** 时间分割弹窗数据 */
      changeTime: {
        visible: false,
        // 是否显示时间分割弹窗
        storelist: [] // 需要变更时间的列表
      },
      mainSubjectType: '',
      otherSubjectType: '',
      otherSubjectList: [],
      allStoreCheckList: [],
      storeList: [],
      previewStoreList: []
    }, "pickerOptions", {
      disabledDate: function disabledDate(time) {
        var now = new Date();
        var dayOfWeek = now.getDay(); // Sunday is 0, Monday is 1, ..., Saturday is 6
        var daysUntilNextMonday = dayOfWeek === 0 ? 1 : 7 - dayOfWeek;
        var minDate = new Date(now);
        minDate.setDate(minDate.getDate() + daysUntilNextMonday);
        var maxDate = new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate() + 14);
        return time > maxDate || time < minDate;
      }
    }), "defaultSort_main", {
      prop: '',
      order: ''
    }), "defaultSort_other", {
      prop: '',
      order: ''
    }), "defaultSort_recommed", {
      prop: '',
      order: ''
    }), "storeCodeErr", []);
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return "".concat(this.activeStep === 4 ? this.$t('doubleWeekPlan.title.storePreview') : this.$t('doubleWeekPlan.title.storeVisitAdvanced'), "\uFF1A").concat(this.stepOneDataForm.planTaskDate.replaceAll('-', '/') || '');
    },
    startOptions: function startOptions() {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.pickerOptions), {}, {
        maxTime: this.form.planTaskEndTime
      });
    },
    endOptions: function endOptions() {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.pickerOptions), {}, {
        minTime: this.form.planTaskStartTime
      });
    },
    // 是创建任务流程
    isTask: function isTask() {
      return this.actualPlanTaskFlag === _index2.PT_STATUS_TASK;
    }
  },
  watch: {
    isShowModel: {
      handler: function handler(val, old) {
        if (val !== old && !val) {
          this.resetModel();
        }
      }
    }
  },
  methods: {
    // open dialog init
    init: function init(type) {
      // 没有选中日期不能操作
      if (!this.actDateinfo.planTaskDate) {
        return false;
      }
      this.isShowModel = true;
      this.actualPlanTaskFlag = type;
      var planTaskDate = this.actDateinfo.planTaskDateStr.replaceAll('/', '-');
      this.stepOneDataForm.planTaskDate = planTaskDate;
      // 根据ba描述，目前门店计划没编辑
      // this.queryList()
    },
    queryList: function queryList() {
      if (this.activeStep === 1) {
        this.queryMainThemeList();
      } else if (this.activeStep === 2) {
        this.queryOtherThemeList();
      } else if (this.activeStep === 3) {
        this.queryOtherThemeList();
      }
    },
    // get table list
    queryMainThemeList: function queryMainThemeList() {
      var _this2 = this;
      if (this.table_main.sourceApi) {
        this.table_main.sourceApi.cancel('cancel');
      }
      this.table_main.sourceApi = _axios.default.CancelToken.source();
      var others = Object.assign({}, ((0, _objectDestructuringEmpty2.default)(this.searchForm), this.searchForm));
      // 剔除不需要的字段
      delete others.PCD;
      var param = {
        currPage: this.table_main.currPage,
        limit: this.table_main.limit,
        smodel: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, others), {}, {
          orderByField: this.defaultSort_main.prop,
          ascOrDesc: this.defaultSort_main.order === 'ascending' ? 'asc' : 'desc'
        })
      };
      this.table_main.listLoading = true;
      (0, _doubleWeekPlan.getListAdvancedVisitStore)(param, this.table_main.sourceApi.token).then(function (res) {
        var _ref2 = res || {},
          data = _ref2.data;
        var _ref3 = data || {},
          _ref3$items = _ref3.items,
          items = _ref3$items === void 0 ? [] : _ref3$items,
          _ref3$totalCount = _ref3.totalCount,
          totalCount = _ref3$totalCount === void 0 ? 0 : _ref3$totalCount;
        _this2.table_main.list = items;
        _this2.table_main.total = totalCount;
        // 在新增计划模式下，切换列表需要重置选中项目
        if (_this2.actualPlanTaskFlag === _index2.PT_STATUS_PLAN) {
          _this2.$nextTick(function () {
            console.log('===this.table_main.storeChecked==', _this2.table_main.storeChecked);
            var storeCodes = _this2.table_main.storeChecked.map(function (i) {
              return i.storeCode;
            });
            // this.$refs.table.toggleRowSelection(this.lists[i],true)
            console.log('===storeCodes==', storeCodes);
            if (storeCodes.length > 0) {
              _this2.table_main.list.forEach(function (items, index) {
                if (storeCodes.indexOf(items.storeCode) >= 0) {
                  _this2.$refs.table_main.toggleRowSelection(items, true);
                }
              });
            }
          });
        }
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
      }).finally(function () {
        _this2.table_main.listLoading = false;
      });
    },
    // get other
    queryOtherThemeList: function queryOtherThemeList() {
      var _this3 = this;
      if (this.table_other.sourceApi) {
        this.table_other.sourceApi.cancel('cancel');
      }
      this.table_other.sourceApi = _axios.default.CancelToken.source();
      var others = Object.assign({}, ((0, _objectDestructuringEmpty2.default)(this.searchForm), this.searchForm));
      // 剔除不需要的字段
      delete others.PCD;
      var param = {
        currPage: this.table_other.currPage,
        limit: this.table_other.limit,
        smodel: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, others), {}, {
          'subjectType': this.otherSubjectType,
          orderByField: this.defaultSort_other.prop,
          ascOrDesc: this.defaultSort_other.order === 'ascending' ? 'asc' : 'desc'
        })
      };
      console.log('-----this.table_main.storeChecked------', this.table_other.storeChecked);
      this.table_other.listLoading = true;
      (0, _doubleWeekPlan.getListSecondlyAdvancedVisitStore)(param, this.table_other.sourceApi.token).then(function (res) {
        var _ref4 = res || {},
          data = _ref4.data;
        var _ref5 = data || {},
          _ref5$items = _ref5.items,
          items = _ref5$items === void 0 ? [] : _ref5$items,
          _ref5$totalCount = _ref5.totalCount,
          totalCount = _ref5$totalCount === void 0 ? 0 : _ref5$totalCount;
        _this3.table_other.list = items;
        _this3.table_other.total = totalCount;
        // 在新增计划模式下，切换列表需要重置选中项目
        if (_this3.actualPlanTaskFlag === _index2.PT_STATUS_PLAN) {
          _this3.$nextTick(function () {
            var storeCodes = _this3.table_other.storeChecked.map(function (i) {
              return i.storeCode;
            });
            // this.$refs.table.toggleRowSelection(this.lists[i],true)
            if (storeCodes.length > 0) {
              _this3.table_other.list.forEach(function (items, index) {
                if (storeCodes.indexOf(items.storeCode) >= 0) {
                  _this3.$refs.table_other.toggleRowSelection(items, true);
                }
              });
            }
          });
        }
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
      }).finally(function () {
        _this3.table_other.listLoading = false;
      });
    },
    // get recommend
    queryRecommendList: function queryRecommendList() {
      var _this4 = this;
      if (this.table_recommend.sourceApi) {
        this.table_recommend.sourceApi.cancel('cancel');
      }
      this.table_recommend.sourceApi = _axios.default.CancelToken.source();
      var others = Object.assign({}, ((0, _objectDestructuringEmpty2.default)(this.searchForm), this.searchForm));
      // 剔除不需要的字段
      delete others.PCD;
      var param = {
        currPage: this.table_recommend.currPage,
        limit: this.table_recommend.limit,
        smodel: {
          'subjectType': this.mainSubjectType,
          'provinceCode': this.searchForm.provinceCode,
          'cityCode': this.searchForm.cityCode,
          'districtCode': this.searchForm.districtCode,
          'checkedStoreCodeList': this.searchForm.checkedStoreCodeList,
          'bLat': this.searchForm.bLat,
          'bLong': this.searchForm.bLong
          // orderByField: this.defaultSort.prop,
          // ascOrDesc: this.defaultSort.order === 'ascending' ? 'asc' : 'desc'
        }
      };
      this.table_recommend.listLoading = true;
      (0, _doubleWeekPlan.getListRecommendAdvancedVisitStore)(param, this.table_recommend.sourceApi.token).then(function (res) {
        var _ref6 = res || {},
          data = _ref6.data;
        var _ref7 = data || {},
          _ref7$items = _ref7.items,
          items = _ref7$items === void 0 ? [] : _ref7$items,
          _ref7$totalCount = _ref7.totalCount,
          totalCount = _ref7$totalCount === void 0 ? 0 : _ref7$totalCount;
        _this4.table_recommend.list = items;
        _this4.table_recommend.total = totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
      }).finally(function () {
        _this4.table_recommend.listLoading = false;
      });
    },
    // search table
    searchData: function searchData() {
      // console.log(999, this.searchForm)
      // this.table.currPage = 1
      if (this.activeStep === 1) {
        this.table_main.currPage = 1;
      } else if (this.activeStep === 2) {
        this.table_other.currPage = 1;
      }
      this.queryList();
    },
    resetSearchForm: function resetSearchForm() {
      var data = this.$options.data.call(this);
      // this.searchForm = data.searchForm

      this.searchForm.PCD = this.stepOneDataForm.PCD;
      this.searchForm.province = this.stepOneDataForm.province;
      this.searchForm.provinceCode = this.stepOneDataForm.provinceCode;
      this.searchForm.city = this.stepOneDataForm.city;
      this.searchForm.cityCode = this.stepOneDataForm.cityCode;
      this.searchForm.district = this.stepOneDataForm.district;
      this.searchForm.districtCode = this.stepOneDataForm.districtCode;
      this.searchForm.storeName = '';
      this.searchForm.storeCode = '';
      this.searchForm.contactor = '';
      this.searchForm.storeAddr = '';
      this.searchForm.retailerType = '';
      this.searchForm.rtlRtmCategory = '';
      this.searchForm.isBaiLian = '';
      this.searchForm.mainBusiness = '';
      this.searchForm.signBoardBrand = '';
      this.searchForm.storeType = '';
      this.searchForm.storeContact = '';
      if (this.activeStep != 2) {
        this.searchForm.distanceBetweenVisits = 'distance3';
      }
    },
    resetData: function resetData() {
      var _this5 = this;
      this.resetSearchForm();
      this.$nextTick(function () {
        _this5.searchData();
      });
    },
    // store checked event
    handleStoreCheckedMain: function handleStoreCheckedMain(rows) {
      console.log(999, rows);
      if (this.table_main.listLoading) {
        return false;
      }
      // 当前页选中
      var checkedCodes = rows.map(function (i) {
        return i.storeCode;
      });
      // 当前页取消选中
      var unCheckedRows = this.table_main.list.filter(function (i) {
        return checkedCodes.indexOf(i.storeCode) < 0;
      });
      var unCheckedCodes = unCheckedRows.map(function (i) {
        return i.storeCode;
      });
      var rowsMap = new Map();
      this.table_main.storeChecked.concat(rows).forEach(function (i) {
        rowsMap.set(i.storeCode, i);
      });
      var arr = Array.from(rowsMap.values()).filter(function (i) {
        return unCheckedCodes.indexOf(i.storeCode) < 0;
      });
      this.table_main.storeChecked = arr;
    },
    handleStoreCheckedOther: function handleStoreCheckedOther(rows) {
      // console.log(999, rows)
      if (this.table_other.listLoading) {
        return false;
      }
      // 当前页选中
      var checkedCodes = rows.map(function (i) {
        return i.storeCode;
      });
      // 当前页取消选中
      var unCheckedRows = this.table_other.list.filter(function (i) {
        return checkedCodes.indexOf(i.storeCode) < 0;
      });
      var unCheckedCodes = unCheckedRows.map(function (i) {
        return i.storeCode;
      });
      var rowsMap = new Map();
      this.table_other.storeChecked.concat(rows).forEach(function (i) {
        rowsMap.set(i.storeCode, i);
      });
      var arr = Array.from(rowsMap.values()).filter(function (i) {
        return unCheckedCodes.indexOf(i.storeCode) < 0;
      });
      this.table_other.storeChecked = arr;
    },
    handleStoreCheckedRecommend: function handleStoreCheckedRecommend(rows) {
      // console.log(999, rows)
      if (this.table_recommend.listLoading) {
        return false;
      }
      // 当前页选中
      var checkedCodes = rows.map(function (i) {
        return i.storeCode;
      });
      // 当前页取消选中
      var unCheckedRows = this.table_recommend.list.filter(function (i) {
        return checkedCodes.indexOf(i.storeCode) < 0;
      });
      var unCheckedCodes = unCheckedRows.map(function (i) {
        return i.storeCode;
      });
      var rowsMap = new Map();
      this.table_recommend.storeChecked.concat(rows).forEach(function (i) {
        rowsMap.set(i.storeCode, i);
      });
      var arr = Array.from(rowsMap.values()).filter(function (i) {
        return unCheckedCodes.indexOf(i.storeCode) < 0;
      });
      this.table_recommend.storeChecked = arr;
    },
    // 更多门店推荐
    onAddStore: function onAddStore() {
      this.isShowAddMoreStoreModel = true;
    },
    // 取消按钮前置操作
    onBeforeCancel: function onBeforeCancel() {
      this.stepOneDataForm = {
        planTaskDate: '',
        planTaskStartTime: '09:00',
        planTaskEndTime: '17:00',
        subjectType: '',
        province: '',
        provinceCode: '',
        city: '',
        cityCode: '',
        district: '',
        districtCode: ''
      };
      this.stepTwoDataForm.storeCheckList = [];
      this.stepThreeDataForm.storeCheckList = [];
      this.stepThreeDataForm.recommendedStoreCheckList = [];
      this.stepFourDataForm.firstStore = '';
      this.stepFourDataForm.lastStore = '';
      this.table_main = {
        listLoading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        list: [],
        sourceApi: null,
        // api timer
        storeChecked: [],
        // 访店计划流程 store info array
        taskStoreChecked: {}
      };
      this.table_other = {
        listLoading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        list: [],
        sourceApi: null,
        // api timer
        storeChecked: [],
        // 访店计划流程 store info array
        taskStoreChecked: {}
      };
      this.table_recommend = {
        listLoading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        list: [],
        sourceApi: null,
        // api timer
        storeChecked: [],
        // 访店计划流程 store info array
        taskStoreChecked: {}
      };
      this.activeStep = 0;
      return true;
    },
    onBeforeClose: function onBeforeClose() {
      this.stepOneDataForm = {
        planTaskDate: '',
        planTaskStartTime: '09:00',
        planTaskEndTime: '17:00',
        subjectType: '',
        province: '',
        provinceCode: '',
        city: '',
        cityCode: '',
        district: '',
        districtCode: '',
        PCD: []
      };
      // // this.$refs.stepOneDataForm.clearValidate()
      this.stepTwoDataForm.storeCheckList = [];
      this.stepThreeDataForm.storeCheckList = [];
      this.stepThreeDataForm.recommendedStoreCheckList = [];
      this.stepFourDataForm.firstStore = '';
      this.stepFourDataForm.lastStore = '';
      this.table_main = {
        listLoading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        list: [],
        sourceApi: null,
        // api timer
        storeChecked: [],
        // 访店计划流程 store info array
        taskStoreChecked: {}
      };
      this.table_other = {
        listLoading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        list: [],
        sourceApi: null,
        // api timer
        storeChecked: [],
        // 访店计划流程 store info array
        taskStoreChecked: {}
      };
      this.table_recommend = {
        listLoading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        list: [],
        sourceApi: null,
        // api timer
        storeChecked: [],
        // 访店计划流程 store info array
        taskStoreChecked: {}
      };
      this.activeStep = 0;
      return false;
    },
    // 保存
    saveItem: function () {
      var _saveItem = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              return _context.a(2);
          }
        }, _callee);
      }));
      function saveItem() {
        return _saveItem.apply(this, arguments);
      }
      return saveItem;
    }(),
    /**
     * 计划
     */
    // 保存计划
    savePlanItem: function savePlanItem() {
      var _this6 = this;
      // console.log(1111, this.table.storeChecked.map(i => i.storeCode))
      if (this.table.storeChecked.length <= 0) {
        this.$message.warning(this.$t('doubleWeekPlan.error.storeChecked'));
        return false;
      }
      this.$refs['dataForm'].clearValidate();
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) {
          _this6.$message.error(_this6.$t('doubleWeekPlan.error.planRangeTime'));
          return;
        }

        // 自行分割时间并保存
        _this6.changeTime.visible = true;
        _this6.getChangeTimeClip(_this6.table.storeChecked, _this6.form.planTaskStartTime, _this6.form.planTaskEndTime);

        // // 重复触发
        // if (!this.canSubmit) {
        //   return false
        // }
        // this.canSubmit = false

        // // 获取时间区间分割params
        var prevParams = {
          planTaskDate: _this6.actDateinfo.planTaskDate.replaceAll('-', '') || '',
          planTaskStartTime: _this6.form.planTaskStartTime,
          planTaskEndTime: _this6.form.planTaskEndTime,
          storeCodeList: _this6.table.storeChecked.map(function (i) {
            return i.storeCode;
          })
        };
        // // 获取时间区间分割
        (0, _doubleWeekPlan.getAllocateTime)(prevParams).then(function (prevRes) {
          var _ref8 = prevRes || {},
            _ref8$data = _ref8.data,
            data = _ref8$data === void 0 ? [] : _ref8$data;
          // 自行分割时间并保存
          _this6.changeTime.visible = true;
          // this.changeTime.storelist = data
          _this6.getChangeTimeClip(data, prevParams.planTaskStartTime, prevParams.planTaskEndTime);
        }).finally(function () {
          _this6.canSubmit = true;
        });
      });
    },
    queryAiRoute: function queryAiRoute() {
      var _this7 = this;
      console.log(this.allStoreCheckList);
      // 首访门店
      var firstStore = this.allStoreCheckList.filter(function (item) {
        return item.storeCode === _this7.stepFourDataForm.firstStore;
      });
      // 结束门店
      var lastStore = this.allStoreCheckList.filter(function (item) {
        return item.storeCode === _this7.stepFourDataForm.lastStore;
      });
      // 中间门店
      var middleStore = this.allStoreCheckList.filter(function (item) {
        return item.storeCode !== _this7.stepFourDataForm.firstStore && item.storeCode !== _this7.stepFourDataForm.lastStore;
      });
      var newStoreList = [];
      newStoreList = newStoreList.concat(firstStore);
      newStoreList = newStoreList.concat(middleStore);
      newStoreList = newStoreList.concat(lastStore);
      console.log(newStoreList);
      // 获取时间区间分割params
      var prevParams = {
        storeList: newStoreList || [],
        endStoreFlag: this.stepFourDataForm.lastStore !== '' ? 1 : 0
      };
      console.log(prevParams);
      // // 获取时间区间分割
      (0, _doubleWeekPlan.getAiRoute)(prevParams).then(function (prevRes) {
        console.log('-=---prevRes---111-', prevRes);
        var _ref9 = prevRes || {},
          _ref9$data = _ref9.data,
          data = _ref9$data === void 0 ? [] : _ref9$data,
          success = _ref9.success;
        if (success) {
          _this7.storeList = data['storeList'] || [];
          _this7.allocPlanItem();
        }
      }).catch(function (err) {
        console.log('-=---prevRes--222--', err);
        var errorInfos = err.errorInfos;
        if (errorInfos && errorInfos.length > 0) {
          if (errorInfos.length > 0) {
            _elementUi.Message.error(errorInfos[0]['errMsg'] || 'Error');
          }
          _this7.storeList = newStoreList;
          _this7.allocPlanItem();
        }
        // this.$message.error('保存失败')
      }).finally(function () {
        // this.canSubmit = true
      });
    },
    allocPlanItem: function allocPlanItem() {
      var _this8 = this;
      var _this = this;
      // console.log(1111, this.table.storeChecked.map(i => i.storeCode))
      // 自行分割时间并保存
      // // 获取时间区间分割params
      // this.previewStoreList = this.storeList
      // this.getChangeTimeClip(
      //   this.storeList,
      //   this.stepOneDataForm.planTaskStartTime,
      //   this.stepOneDataForm.planTaskEndTime
      // )
      // this.activeStep = this.activeStep + 1
      // setTimeout(function() {
      //   _this.$refs['planMap2'].init()
      // }, 500)
      var prevParams = {
        planTaskDate: this.stepOneDataForm.planTaskDate.replaceAll('-', '') || '',
        planTaskStartTime: this.stepOneDataForm.planTaskStartTime,
        planTaskEndTime: this.stepOneDataForm.planTaskEndTime,
        storeList: this.storeList
      };
      console.log(prevParams);
      // // 获取时间区间分割
      (0, _doubleWeekPlan.getAllocateTime)(prevParams).then(function (prevRes) {
        var _ref0 = prevRes || {},
          _ref0$data = _ref0.data,
          data = _ref0$data === void 0 ? [] : _ref0$data;
        _this8.previewStoreList = data;
        // this.getChangeTimeClip(
        //   this.previewStoreList,
        //   this.stepOneDataForm.planTaskStartTime,
        //   this.stepOneDataForm.planTaskEndTime
        // )
        console.log('-=---------previewStoreList-------', _this8.previewStoreList);
        _this8.activeStep = _this8.activeStep + 1;
        setTimeout(function () {
          _this.$refs['planMap2'].init();
        }, 500);
      }).finally(function () {
        // this.canSubmit = true
      });
    },
    /**
     * 分割时间
     */
    getChangeTimeClip: function getChangeTimeClip(data, startTxt, endTxt) {
      console.log('-=---getChangeTimeClip--', data);
      var diff = 30; // 每个片段占据的时长
      var start = (0, _utils.getTimenums)(startTxt);
      var end = (0, _utils.getTimenums)(endTxt);
      var targetLen = data.length; // 需要拆分给对应的门店数
      var totalLen = Math.ceil((end - start) / diff); // 因为有23:59的特殊情况，需要取整
      var avaClip = Math.floor(totalLen / targetLen); // 最小平均值
      var lClip = totalLen % targetLen; // 余数
      // 需要添加的时间片数量
      var arr = Array(targetLen).fill(avaClip);
      if (avaClip === 0) {
        // 正叙加
        arr = arr.map(function (i) {
          var clip = i;
          if (lClip > 0) {
            clip++;
            lClip--;
          }
          return clip;
        });
      } else {
        // 倒叙加
        arr = arr.reverse().map(function (i) {
          var clip = i;
          if (lClip > 0) {
            clip++;
            lClip--;
          }
          return clip;
        }).reverse();
      }
      // 开始拆分
      var curStart = start;
      // const oldList = this.changeTime.storelist
      // this.changeTime.storelist.splice(0, oldList.length, ...data.map((item, index) => {
      //   const actDiff = diff * arr[index]
      //   if (actDiff === 0) {
      //     // 没分时间
      //     // 赋值
      //     item.planTaskStartTime = ''
      //     item.planTaskEndTime = ''
      //   } else {
      //     // 分了时间
      //     let curEnd = curStart + diff * arr[index]
      //     // 针对23:59格式化
      //     if (curEnd > end) {
      //       curEnd = end
      //     }
      //     // 赋值
      //     item.planTaskStartTime = getTimeStr(curStart)
      //     item.planTaskEndTime = getTimeStr(curEnd)
      //     // 余数减少
      //     lClip--
      //     curStart = curEnd
      //   }
      //   return item
      // }))
      this.storelist = (0, _toConsumableArray2.default)(data.map(function (item, index) {
        var actDiff = diff * arr[index];
        if (actDiff === 0) {
          // 没分时间
          // 赋值
          item.planTaskStartTime = '';
          item.planTaskEndTime = '';
        } else {
          // 分了时间
          var curEnd = curStart + diff * arr[index];
          // 针对23:59格式化
          if (curEnd > end) {
            curEnd = end;
          }
          // 赋值
          item.planTaskStartTime = (0, _utils.getTimeStr)(curStart);
          item.planTaskEndTime = (0, _utils.getTimeStr)(curEnd);
          // 余数减少
          lClip--;
          curStart = curEnd;
        }
        return item;
      }));
    },
    /**
     * 任务
     */
    // 保存任务
    saveTaskItem: function () {
      var _saveTaskItem = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var detailList, i, paramList, a01params, params;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              // 重复触发
              this.storeCodeErr = [];
              detailList = []; // const bailiandetailList = []
              // eslint-disable-next-line no-empty
              for (i = 0; i < this.previewStoreList.length; i++) {
                console.log(this.previewStoreList[i]['planTaskStartTime']);
                if ((this.previewStoreList[i]['planTaskStartTime'] || '') === '' || (this.previewStoreList[i]['planTaskEndTime'] || '') === '') {
                  this.storeCodeErr.push(this.previewStoreList[i]['storeCode']);
                }
                detailList.push({
                  'planTaskTitle': this.previewStoreList[i]['storeName'],
                  'planTaskStartTime': this.previewStoreList[i]['planTaskStartTime'],
                  'planTaskEndTime': this.previewStoreList[i]['planTaskEndTime'],
                  'storeCode': this.previewStoreList[i]['storeCode'] || '',
                  'cusRegion': '',
                  'cusRegionCode': '',
                  'cusCity': '',
                  'cusCityCode': '',
                  'cusDistrict': '',
                  'cusDistrictCode': '',
                  'customerName': this.previewStoreList[i]['storeName'] || '',
                  'customerAddress': this.previewStoreList[i]['storeAddress'] || '',
                  'visitPurpose1': '',
                  'visitPurpose2': '',
                  'remark': '',
                  'bLat': this.previewStoreList[i]['bLat'] || '',
                  'bLong': this.previewStoreList[i]['bLong'] || '',
                  'baiLianFlag': this.previewStoreList[i]['baiLianFlag'] || ''
                });
                // eslint-disable-next-line no-empty
                // if (this.previewStoreList[i]['baiLianFlag'] === 'Y') {
                //   bailiandetailList.push({
                //     'planTaskTitle': this.previewStoreList[i]['storeName'],
                //     'planTaskStartTime': this.previewStoreList[i]['planTaskStartTime'],
                //     'planTaskEndTime': this.previewStoreList[i]['planTaskEndTime'],
                //     'storeCode': this.previewStoreList[i]['storeCode'] || '',
                //     'cusRegion': '',
                //     'cusRegionCode': '',
                //     'cusCity': '',
                //     'cusCityCode': '',
                //     'cusDistrict': '',
                //     'cusDistrictCode': '',
                //     'customerName': this.previewStoreList[i]['storeName'] || '',
                //     'customerAddress': this.previewStoreList[i]['storeAddress'] || '',
                //     'visitPurpose1': '-',
                //     'visitPurpose2': '-',
                //     'remark': '-',
                //     'bLat': this.previewStoreList[i]['bLat'] || '',
                //     'bLong': this.previewStoreList[i]['bLong'] || ''
                //   })
                // } else {
                //   detailList.push({
                //     'planTaskTitle': this.previewStoreList[i]['storeName'],
                //     'planTaskStartTime': this.previewStoreList[i]['planTaskStartTime'],
                //     'planTaskEndTime': this.previewStoreList[i]['planTaskEndTime'],
                //     'storeCode': this.previewStoreList[i]['storeCode'] || '',
                //     'cusRegion': '',
                //     'cusRegionCode': '',
                //     'cusCity': '',
                //     'cusCityCode': '',
                //     'cusDistrict': '',
                //     'cusDistrictCode': '',
                //     'customerName': this.previewStoreList[i]['storeName'] || '',
                //     'customerAddress': this.previewStoreList[i]['storeAddress'] || '',
                //     'visitPurpose1': '-',
                //     'visitPurpose2': '-',
                //     'remark': '-',
                //     'bLat': this.previewStoreList[i]['bLat'] || '',
                //     'bLong': this.previewStoreList[i]['bLong'] || '',
                //     'baiLianFlag': this.previewStoreList[i]['baiLianFlag'] || ''
                //   })
                // }
              }
              if (!(this.storeCodeErr.length > 0)) {
                _context2.n = 1;
                break;
              }
              this.$message({
                message: this.$t('doubleWeekPlan.error.visitTime'),
                type: 'error'
              });
              return _context2.a(2);
            case 1:
              if (this.canSubmit) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2, false);
            case 2:
              this.canSubmit = false;
              paramList = [];
              if (detailList.length > 0) {
                a01params = {
                  'planTaskDate': this.stepOneDataForm.planTaskDate.replaceAll('-', ''),
                  'planTaskType': 'A01',
                  'actualPlanTaskFlag': 'N',
                  'detailList': detailList
                };
                paramList.push(a01params);
              }
              // if (bailiandetailList.length > 0) {
              //   var a10Params = {
              //     'planTaskDate': this.stepOneDataForm.planTaskDate.replaceAll('-', ''),
              //     'planTaskType': 'A01',
              //     'actualPlanTaskFlag': 'N',
              //     'detailList': bailiandetailList
              //   }
              //   paramList.push(a10Params)
              // }
              params = {
                'paramList': paramList
              }; // 实际保存
              this.api_save(params);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function saveTaskItem() {
        return _saveTaskItem.apply(this, arguments);
      }
      return saveTaskItem;
    }(),
    // api 保存方法 , 针对 step2拆分时间后保存的报错定制展示形式
    api_save: function api_save(params) {
      var _this9 = this;
      (0, _doubleWeekPlan.savePlanTaskNew)(params).then(function () {
        _this9.$message({
          message: _this9.$t('common.saveSuccess'),
          type: 'success'
        });
        _this9.$emit('refresh');
        _this9.onBeforeClose();
        _this9.isShowModel = false;
      }).catch(function (err) {
        // if (isStep2) {
        //   // 在changeTime组件内反馈
        //   this.$refs['changeTimeRef'].errHandle(err)
        // } else {
        //   // 在当前组件内反馈
        //   this.errorHandle(err, 'dataForm')
        // }
        // 如果是时间冲突了，则弹出冲突弹窗
        var detailList = [];
        var paramListp = params['paramList'];
        var actualPlanTaskFlag = 'N';
        var planTaskDate = '';
        for (var i in paramListp) {
          planTaskDate = paramListp[i]['planTaskDate'];
          detailList = detailList.concat(paramListp[i]['detailList']);
        }
        // const { detailList = [], actualPlanTaskFlag, planTaskDate } = params['paramList']
        var conflitParams = {
          actualPlanTaskFlag: actualPlanTaskFlag,
          planTaskDate: planTaskDate,
          timeList: detailList.map(function (i) {
            return {
              startTime: i.planTaskStartTime,
              endTime: i.planTaskEndTime
            };
          })
        };
        console.log('===conflitParams===', conflitParams);
        _this9.timeConflitHandle(err.errorInfos, conflitParams);
      }).finally(function () {
        _this9.canSubmit = true;
      });
    },
    // 重置弹窗
    resetModel: function resetModel() {
      this.canSubmit = true;
      this.activeStep = 0;
      this.clearForm();
      this.clearTable();
      this.clearChangeTime();
    },
    // reset form
    clearForm: function clearForm() {
      console.log('clear form');
      try {
        var dataFormDom = this.$refs['dataForm'];
        var searchFormDom = this.$refs['searchForm'];
        dataFormDom && dataFormDom.resetFields();
        searchFormDom && searchFormDom.resetFields();
      } catch (error) {
        console.log(error);
      }
      var data = this.$options.data.call(this);
      this.onBeforeClose();
      this.form = data.form;
      this.initForm = data.initForm;
      this.searchForm = data.searchForm;
      this.taskForm = data.taskForm;
    },
    clearTable: function clearTable() {
      var data = this.$options.data.call(this);
      this.table = data.table;
    },
    // 重置时间分割弹窗
    clearChangeTime: function clearChangeTime() {
      try {
        var changeTimeDom = this.$refs['changeTimeRef'];
        changeTimeDom && changeTimeDom.resetFields();
      } catch (error) {
        console.log(error);
      }
      var data = this.$options.data.call(this);
      this.changeTime = data.changeTime;
    },
    searchMain: function searchMain() {
      var _this0 = this;
      this.mainSubjectType = this.stepOneDataForm.subjectType;
      var subjectList = JSON.parse(JSON.stringify(this.optConfig.targetTopicType));
      this.otherSubjectList = subjectList.filter(function (item) {
        return item['code'] !== _this0.mainSubjectType;
      });
      this.otherSubjectType = this.otherSubjectList[0]['code'];
      this.searchForm.subjectType = this.mainSubjectType;
      this.searchForm.province = this.stepOneDataForm.province;
      this.searchForm.provinceCode = this.stepOneDataForm.provinceCode;
      this.searchForm.city = this.stepOneDataForm.city;
      this.searchForm.cityCode = this.stepOneDataForm.cityCode;
      this.searchForm.district = this.stepOneDataForm.district;
      this.searchForm.districtCode = this.stepOneDataForm.districtCode;
      this.searchForm.checkedStoreCodeList = [];
      this.searchForm.PCD = this.stepOneDataForm.PCD;
      this.searchForm.storeName = '';
      this.searchForm.storeCode = '';
      this.searchForm.contactor = '';
      this.searchForm.storeAddr = '';
      this.searchForm.retailerType = '';
      this.searchForm.rtlRtmCategory = '';
      this.searchForm.isBaiLian = '';
      this.searchForm.mainBusiness = '';
      this.searchForm.signBoardBrand = '';
      this.searchForm.storeType = '';
      this.searchForm.storeContact = '';
      this.searchForm.distanceBetweenVisits = 'distance3';
      this.queryMainThemeList();
    },
    searchOther: function searchOther() {
      var storeCheckList = this.table_main.storeChecked;
      // 初始化此主题查询条件
      // this.stepTwoDataForm.storeChecked = storeCheckList
      var checkedStoreCodeList = [];
      for (var mainIndex in storeCheckList) {
        checkedStoreCodeList.push(storeCheckList[mainIndex]['storeCode']);
      }
      this.searchForm.province = this.stepOneDataForm.province;
      this.searchForm.provinceCode = this.stepOneDataForm.provinceCode;
      this.searchForm.city = this.stepOneDataForm.city;
      this.searchForm.cityCode = this.stepOneDataForm.cityCode;
      this.searchForm.district = this.stepOneDataForm.district;
      this.searchForm.districtCode = this.stepOneDataForm.districtCode;
      this.searchForm.checkedStoreCodeList = checkedStoreCodeList;
      this.searchForm.bLat = storeCheckList[0]['bLat'];
      this.searchForm.bLong = storeCheckList[0]['bLong'];
      this.searchForm.storeName = '';
      this.searchForm.storeCode = '';
      this.searchForm.contactor = '';
      this.searchForm.storeAddr = '';
      this.searchForm.retailerType = '';
      this.searchForm.rtlRtmCategory = '';
      this.searchForm.isBaiLian = '';
      this.searchForm.mainBusiness = '';
      this.searchForm.signBoardBrand = '';
      this.searchForm.storeType = '';
      this.searchForm.storeContact = '';
      this.queryOtherThemeList();
    },
    showBackPreviousStepModel: function showBackPreviousStepModel() {
      if (this.activeStep === 1 && this.table_main.storeChecked.length > 0 || this.activeStep === 2 && this.table_other.storeChecked.length > 0 || this.activeStep === 3) {
        this.isShowBackPreviousStepModel = true;
      } else {
        this.goPreviousStep();
      }
    },
    goPreviousStep: function goPreviousStep() {
      var _this1 = this;
      console.log('==activeStep====', this.activeStep);
      if (this.activeStep === 3) {
        this.isShowBackPreviousStepModel = false;
        this.stepFourDataForm.firstStore = '';
        this.stepFourDataForm.lastStore = '';
        this.table_other.currPage = 1;
        this.activeStep = this.activeStep - 1;
        this.searchOther();
      } else if (this.activeStep === 2) {
        this.isShowBackPreviousStepModel = false;
        this.table_other.storeChecked = [];
        this.table_main.currPage = 1;
        this.activeStep = this.activeStep - 1;
        this.searchMain();
      } else if (this.activeStep === 1) {
        this.isShowBackPreviousStepModel = false;
        this.table_main.storeChecked = [];
        this.activeStep = this.activeStep - 1;
        this.resetSearchForm();
        this.$nextTick(function () {
          _this1.searchData();
        });
      } else {
        this.activeStep = this.activeStep - 1;
      }
    },
    goNextStep: function goNextStep() {
      var _this10 = this;
      if (this.activeStep === 0) {
        this.$refs.stepOneDataForm.clearValidate();
        this.$refs.stepOneDataForm.validate(function (valid) {
          if (!valid) return;
          // 初始化主主题查询条件
          _this10.searchMain();
          console.log('===stepOneDataForm==', _this10.stepOneDataForm);
          _this10.activeStep = _this10.activeStep + 1;
        });
      } else if (this.activeStep === 1) {
        console.log('===storeChecked==', this.table_main.storeChecked);
        var storeCheckList = this.table_main.storeChecked;
        if (storeCheckList.length === 0) {
          this.$message.error(this.$t('doubleWeekPlan.table.selectMainStore'));
          return;
        }
        this.stepTwoDataForm.storeCheckList = storeCheckList;
        this.activeStep = this.activeStep + 1;
        this.resetSearchForm();
        this.$nextTick(function () {
          _this10.searchOther();
        });
      } else if (this.activeStep === 2) {
        var mainStoreCheckList = this.table_main.storeChecked;
        // ci主题门店
        var otherStoreCheckList = this.table_other.storeChecked;
        this.stepThreeDataForm.storeCheckList = otherStoreCheckList;
        this.allStoreCheckList = [];
        this.allStoreCheckList = this.allStoreCheckList.concat(mainStoreCheckList);
        this.allStoreCheckList = this.allStoreCheckList.concat(otherStoreCheckList);
        if (this.allStoreCheckList.length > 5) {
          console.log(this.allStoreCheckList);
          this.stepFourDataForm.firstStore = this.allStoreCheckList[0].storeCode;
          this.activeStep = this.activeStep + 1;
          this.resetSearchForm();
        } else {
          if (!this.isShowRecommendModel) {
            var checkedStoreCodeList = [];
            for (var mianIndex1 in mainStoreCheckList) {
              checkedStoreCodeList.push(mainStoreCheckList[mianIndex1]['storeCode']);
            }
            for (var otherIndex in otherStoreCheckList) {
              checkedStoreCodeList.push(otherStoreCheckList[otherIndex]['storeCode']);
            }
            this.searchForm.province = this.stepOneDataForm.province;
            this.searchForm.provinceCode = this.stepOneDataForm.provinceCode;
            this.searchForm.city = this.stepOneDataForm.city;
            this.searchForm.cityCode = this.stepOneDataForm.cityCode;
            this.searchForm.district = this.stepOneDataForm.district;
            this.searchForm.districtCode = this.stepOneDataForm.districtCode;
            this.searchForm.checkedStoreCodeList = checkedStoreCodeList;
            this.searchForm.bLat = mainStoreCheckList[0]['bLat'];
            this.searchForm.bLong = mainStoreCheckList[0]['bLong'];
            // 每次都是新推荐
            this.table_recommend.currPage = 1;
            this.table_recommend.storeChecked = [];
            this.table_recommend.list = [];
            this.isShowRecommendModel = true;
            this.queryRecommendList();
          } else {
            var recommendStoreCheckList = this.table_recommend.storeChecked;
            this.stepThreeDataForm.recommendedStoreCheckList = recommendStoreCheckList;
            this.allStoreCheckList = this.allStoreCheckList.concat(recommendStoreCheckList);
            console.log(this.allStoreCheckList);
            this.isShowRecommendModel = false;
            this.stepFourDataForm.firstStore = this.allStoreCheckList[0].storeCode;
            this.activeStep = this.activeStep + 1;
            this.resetSearchForm();
          }
        }
      } else if (this.activeStep === 3) {
        console.log(this.stepOneDataForm);
        console.log(this.stepTwoDataForm);
        console.log(this.stepThreeDataForm);
        console.log(this.stepFourDataForm);
        if (this.stepFourDataForm.firstStore === '') {
          this.$message.error(this.$t('doubleWeekPlan.table.selectFirstStore'));
          return;
        }
        this.queryAiRoute();
      } else if (this.activeStep === 4) {
        console.log(this.stepOneDataForm);
        console.log(this.stepTwoDataForm);
        console.log(this.stepThreeDataForm);
        console.log(this.stepFourDataForm);
      }
    },
    getAllFirstCheckStoreList: function getAllFirstCheckStoreList() {
      var _this11 = this;
      return this.allStoreCheckList.filter(function (i) {
        return i.storeCode !== _this11.stepFourDataForm.lastStore;
      });
    },
    getAllLastCheckStoreList: function getAllLastCheckStoreList() {
      var _this12 = this;
      return this.allStoreCheckList.filter(function (i) {
        return i.storeCode !== _this12.stepFourDataForm.firstStore;
      });
    },
    getTopicName: function getTopicName(topic) {
      // eslint-disable-next-line no-undef
      var data = this.optConfig.targetTopicType;
      for (var i in data) {
        if (data[i]['code'] === topic) {
          return data[i]['name'];
        }
      }
      return topic;
    },
    changeOtherSubject: function changeOtherSubject(tab) {
      var _this13 = this;
      if (this.otherSubjectType === tab.name) {
        this.table_other.currPage = 1;
        this.resetSearchForm();
        this.$nextTick(function () {
          _this13.queryOtherThemeList();
        });
      }
    },
    showRePlanningModel: function showRePlanningModel() {
      this.isShowRePlanningModel = true;
    },
    replanTask: function replanTask() {
      this.isShowRePlanningModel = false;
      this.stepTwoDataForm.storeCheckList = [];
      this.stepThreeDataForm.storeCheckList = [];
      this.stepThreeDataForm.recommendedStoreCheckList = [];
      this.stepFourDataForm.firstStore = '';
      this.stepFourDataForm.lastStore = '';
      this.table_main = {
        listLoading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        list: [],
        sourceApi: null,
        // api timer
        storeChecked: [],
        // 访店计划流程 store info array
        taskStoreChecked: {}
      };
      this.table_other = {
        listLoading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        list: [],
        sourceApi: null,
        // api timer
        storeChecked: [],
        // 访店计划流程 store info array
        taskStoreChecked: {}
      };
      this.table_recommend = {
        listLoading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        list: [],
        sourceApi: null,
        // api timer
        storeChecked: [],
        // 访店计划流程 store info array
        taskStoreChecked: {}
      };
      this.activeStep = 0;
    },
    getExcludeRange: function getExcludeRange(row) {
      var _this = this;
      return function () {
        var storeCode = row.storeCode;
        var arr = _this.previewStoreList.filter(function (i) {
          return i.storeCode !== storeCode;
        }).map(function (j) {
          return {
            start: j.planTaskStartTime,
            end: j.planTaskEndTime
          };
        });
        return arr;
      };
    },
    sortTable_main: function sortTable_main(_ref1) {
      var column = _ref1.column,
        prop = _ref1.prop,
        order = _ref1.order;
      if (!order) {
        this.defaultSort_main = {
          prop: '',
          order: ''
        };
        this.searchData();
        return;
      }
      this.defaultSort_main = {
        prop: prop,
        order: order
      };
      this.searchData();
    },
    sortTable_other: function sortTable_other(_ref10) {
      var column = _ref10.column,
        prop = _ref10.prop,
        order = _ref10.order;
      if (!order) {
        this.defaultSort_other = {
          prop: '',
          order: ''
        };
        this.searchData();
        return;
      }
      this.defaultSort_other = {
        prop: prop,
        order: order
      };
      this.searchData();
    },
    sortTable_recommend: function sortTable_recommend(_ref11) {
      var column = _ref11.column,
        prop = _ref11.prop,
        order = _ref11.order;
      if (!order) {
        this.defaultSort_recommed = {
          prop: '',
          order: ''
        };
        this.searchData();
        return;
      }
      this.defaultSort_recommed = {
        prop: prop,
        order: order
      };
      this.searchData();
    },
    onRangeChange: function onRangeChange(row) {
      console.log('------', row);
      var index = this.storeCodeErr.indexOf(row.storeCode);
      this.storeCodeErr.splice(index, 1);
      this.previewStoreList = JSON.parse(JSON.stringify(this.previewStoreList));
    },
    hasErrorStore: function hasErrorStore(storeCode) {
      return this.storeCodeErr.indexOf(storeCode) > -1;
    }
  }
};